import './styles/sftp-gateway-item.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import moment     from 'moment'
import classnames from 'classnames'

function formatTimeCompact(time) {
  return moment(time).format('h:mm A')
}

export default class SFTPGatewayItem extends React.Component {
  static propTypes = {
    item:    PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  renderHighlight = (title, message, failed) => {
    const className = classnames('item-highlight ui mini message', { successful: !failed, failed })        

    return (
      <div className={className}>
        <div className="title">{ title }</div>
        <div className="message">{ message }</div>        
      </div>
    )
  }

  renderTimeRange = ({ startTime, endTime }) => {
    const duration = moment.duration(endTime - startTime, 'milliseconds')

    const start  = moment(startTime)
    const end    = moment(endTime)
    const diff   = end.diff(start)
    const result = moment.utc(diff)
          
    const value  = duration.asMinutes() > 1
      ? `${result.format('m')} min ${result.format('s')} sec`
      : `${result.format('s')} sec`

    return (
      <div className="time-range">
        <div className="range-item">{ `start: ${formatTimeCompact(startTime)}` }</div>
        <div className="range-dash" />
        <div className="range-value">{ value }</div>
        <div className="range-dash" />
        <div className="range-item">{ `end: ${formatTimeCompact(endTime)}` }</div>
      </div>
    )
  }
  
  render() {
    const { item } = this.props

    const timestamp = item.executionStartTime
      ? moment(item.timestamp).format('YYYY-MM-DD')
      : moment(item.timestamp).format('YYYY-MM-DD h:mm A')
    const failed    = item.failed
    
    return (
      <div className="sftp-gateway-item">
        <div className="details">
          { this.renderHighlight('Status',    failed ? "ERROR" : "SUCCESSFUL", failed) }
          { item.executionStartTime && this.renderTimeRange({ startTime: item.executionStartTime, endTime: item.timestamp }) }
          <div className="date">{ timestamp  }</div>
        </div>
      </div>      
    )
  }
}